export default {
  DELTA_DONATION_AND_TIP: 'ui_v2',
};
